import { createMultiStyleConfigHelpers } from '@chakra-ui/react'

export const helper = createMultiStyleConfigHelpers(['wrapper'])

export const PriceBreakdownSummary = helper.defineMultiStyleConfig({
  baseStyle: {},
})
